/* eslint-disable */
import * as React from 'react';
import { ReactNode, SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';

// Custom Components
import { PopoverProps } from '@mui/material/Popover';
import TableHeaderButton from './TableHeaderButton';

interface TableHeaderMenuButtonProps {
  children?: ReactNode;
  tooltip?: any;
}

const TableHeaderMenuButton: React.FC<TableHeaderMenuButtonProps> = (props) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState<PopoverProps['anchorEl']>(null);

  const { tooltip, children } = props;

  const handleClick = (evt: SyntheticEvent): void => setAnchorEl(evt.currentTarget);

  const handleClose = (): void => setAnchorEl(null);

  // children render their own MenuItem, they only need a way to close the menu
  const childrenWithProps: ReactNode | undefined | null = React.Children.map(children, (child) =>
    React.isValidElement(child) ? React.cloneElement(child as React.ReactElement<any>, { onMenuItemClick: handleClose }) : child
  );

  return (
    <>
      <TableHeaderButton
        onClick={handleClick}
        variant="outlined"
        sx={{ display: { xs: 'none', sm: 'flex' } }}
        startIcon={<MenuIcon />}
        tooltip={tooltip ?? ''}
      >
        {t('buttons.export')}
      </TableHeaderButton>
      <Menu
        id="table-header-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        sx={{
          '.MuiMenu-list': { color: 'common.black' },
        }}
      >
        {childrenWithProps}
      </Menu>
    </>
  );
};

export default TableHeaderMenuButton;
